import React from 'react';
import MainHeader from './Header';
import DemoBanner from '../components/DemoBanner';
import DevBanner, { DEV_BANNER_HEIGHT } from '../components/DevBanner';
import ImpersonationBanner from '../components/ImpersonationBanner';

const MainLayout = ({ children, isHeaderFooter }) => {
  return (
    <main
      id="MainLayout"
      className={isHeaderFooter ? 'is-admin Layouts' : 'Layouts'}
      style={{
        // Banners are position:fixed; layouts read --impersonation-banner-height
        // from the documentElement (set by ImpersonationBanner) and add it to
        // the DEV-banner offset so the page isn't masked.
        paddingTop: `calc(${DEV_BANNER_HEIGHT}px + var(--impersonation-banner-height, 0px))`,
        '--dev-banner-height': `${DEV_BANNER_HEIGHT}px`,
      }}
    >
      <DevBanner />
      <DemoBanner />
      <ImpersonationBanner />
      {isHeaderFooter ? <MainHeader /> : null}
      {children}
    </main>
  );
};

export default MainLayout;
